// Libs
import React from 'react'
import _ from 'lodash'

// CSS
import './styles.scss'

const DashboardLineTooltip = ({ active, payload, label, median, benchmark, unit }) => {
  if (active && !_.isEmpty(payload)) {
    return (
      <div className="dashboard-line-tooltip">
        <p className="dashboard-line-tooltip__label">{label}</p>
        <p className="dashboard-line-tooltip__value">{payload[0].value + unit}</p>
        <div>
          <span />
          <p>MÉDIA: <span>{median}{unit}</span></p>
        </div>
        {benchmark &&
          <div>
            <span />
            <p>BENCHMARK: <span>{benchmark}{unit}</span></p>
          </div>
        }
      </div>
    );
  }

  return null
};

export default DashboardLineTooltip
